import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";

export const useUpdateShowSales = (id, options = {}) => {
  return useMutation(
    (dto) => http.patch(HTTP_ENDPOINTS.updateShowSales(id), dto),
    options,
  );
};
